export function VerifyPermission(user, { modulo, submodulo, funcao }) {
    if (user?.IS_ADMIN) return true;
    if (!user?.PERMISSIONS?.length) return false;

    return user.PERMISSIONS.some(
        p =>
            (!modulo || p.modulo === modulo) &&
            (!submodulo || p.submodulo === submodulo) &&
            (!funcao || p.funcao === funcao)
    );
}